




import {Component, Ref, Vue} from "vue-property-decorator";
import TariffZoneGroup from '../Tarification/TariffZoneGroup.vue';
import {TarificationTransports, TarificationTypes} from "@/store/tarification/types";

@Component({components: {TariffZoneGroup}})
export default class CallOperatorTariffZoneGroup extends Vue {

  @Ref('tariffZoneGroup') private tariffZoneGroup!: TariffZoneGroup;

  private operatorType: TarificationTypes = TarificationTypes.OPERATOR
  private tarificationTransport: TarificationTransports = TarificationTransports.CALL

  beforeRouteLeave(to: any, from: any, next: any): void {
    this.tariffZoneGroup.beforeLeave(to, from, next);
  }
}
